import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild, effect } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { environment } from 'src/environments/environment';
import { QuotingToolService } from '../quoting-tool.service';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { HelperService } from 'src/app/core/helper/helper.service';
import { MatStepper } from '@angular/material/stepper';
import { AuthService } from '../../auth/auth.service';

interface ProjectDetails {
  iProjectID: string;
  vProjectName: string;
}

@Component({
  selector: 'app-e-quotation',
  templateUrl: './e-quotation.component.html'
})
export class EQuotationComponent implements OnInit {

  getImagePath: any = environment.image_path;

  @ViewChild('stepper') stepper!: MatStepper;

  stepContent: string = "content-1";
  activeStepIndex: number = 0;
  
  projectType: any;
  editProjectForm!: FormGroup;
  serviceForm!: FormGroup;
  productForm!: FormGroup;

  projectID!: any;
  uniqueID!: any;
  userDetails: any;
  access_token!:any;  

  editProjectFormSubmitted = false;
  isLoading: boolean = false;

  isLinear = true;

  projects: ProjectDetails = {
    iProjectID: '-',
    vProjectName: '-',
  }

  memberDomain:any=environment.member_domain;

  stepperNext = this.quotingService.getEStepper();

  constructor(private auth: AuthService,private helper: HelperService,private cdr: ChangeDetectorRef,private router: Router, private modalService: NgbModal, config: NgbModalConfig, private route: ActivatedRoute, private http: HttpClient, private quotingService: QuotingToolService,private authService: AuthenticationService , public dialog: MatDialog, private notificationService: NotificationService) { 
    history.pushState(null, '');
    effect(() => {
      const value = this.stepperNext();
      if(this.stepper){
        const stepperIndex = this.stepper.selectedIndex
        if(stepperIndex==0){
          this.serviceForm.controls['projectID'].setValue(this.projectID);
          this.stepper.next();
        }
        const iProductRequirementId = localStorage.getItem('prId');
        if(stepperIndex==1 && iProductRequirementId !=null){
          this.productForm.controls['projectID'].setValue(iProductRequirementId);
          this.stepper.next();
        }
      }
    }, { allowSignalWrites: true });
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.get('projectID')) {
      this.projectID = this.route.snapshot.queryParamMap.get('projectID');
      localStorage.setItem('projectID',this.projectID);
    }else{
      this.projectID = localStorage.getItem('projectID');
    }
    this.callApiBasedOnProjectType(this.projectID);
    if(this.route.snapshot.queryParamMap.get('manage') == '1'){
      if(localStorage.getItem('customer_access_token')){
        this.helper.ClearStorageData();
      }
      let token=this.route.snapshot.queryParamMap.get('quote_token');
      if(token){
        localStorage.setItem('quote_token',token);
      }
    }else{
      localStorage.removeItem('quote_token');
    }

    this.editProjectForm = new FormGroup({
      vProjectName: new FormControl("", [Validators.required,Validators.maxLength(100),Validators.pattern('^[A-Za-z0-9][A-Za-z0-9 ]*$')])
    });

    this.serviceForm = new FormGroup({
      projectID: new FormControl("", [Validators.required])
    });

    this.productForm = new FormGroup({
      projectID: new FormControl("", [Validators.required])
    });
    
    this.uniqueID = localStorage.getItem('ID');
    this.access_token = this.route.snapshot.queryParamMap.get('quote_token') ? this.route.snapshot.queryParamMap.get('quote_token') : localStorage.getItem('customer_access_token');
    const storedStepIndex = localStorage.getItem('currentStepIndex');
    if (storedStepIndex) {
      // this.navigateToExistingStep(parseInt(storedStepIndex, 10));
      this.updateStepContent(parseInt(storedStepIndex, 10));
    } else {
      this.navigateToStep(0); // Default to the first step if no stored index is found
    }
    if (this.access_token) {
      this.GetUserData();
    }
    
  }

  ngOnDestroy(){
    this.modalService.dismissAll();
  }

  ngAfterViewInit(): void {
  }

  onStepperBack(): void {
    const storedStepIndex = Number(localStorage.getItem('currentStepIndex'));
    if (storedStepIndex > 0) {
      let newIndex=storedStepIndex-1;
      this.updateStepContent(newIndex); // Go back in the stepper
    }else{
      this.router.navigate(['quotations']);
    }
  }


  flag:boolean=false;
  // Listen for the browser back event (popstate)
  @HostListener('window:popstate', ['$event'])
  onPopState(event: PopStateEvent): void {
    // Prevent the default browser back action
    event.preventDefault();
    const storedStepIndex = Number(localStorage.getItem('currentStepIndex'));
    if (storedStepIndex > 0) {
      history.pushState(null, '');
      this.flag=true;

      // Trigger your custom "stepper back" behavior
      this.onStepperBack(); // Go back in the stepper
    }else{
    this.flag=false;
    window.location.href='/quotations';
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event): void {
    const storedStepIndex = Number(localStorage.getItem('currentStepIndex'));
    if (storedStepIndex > 0 && this.flag) {
      event.preventDefault(); // Prevent browser default unload behavior
      event.returnValue = false; // Required for some browsers to show confirmation prompt
    }else{
      event.returnValue = true;
    }
  }

  getUser(userData: any) {
    this.userDetails=userData;
  }

  navigateToStep(stepIndex: number) {
    if (this.stepper) {
      this.isLinear = false;
    setTimeout(() => {
      this.stepper.selectedIndex = stepIndex;
      this.isLinear = true;
      this.cdr.detectChanges();
    }, 0);
    }
  }

  navigateToExistingStep(stepIndex:number){
    setTimeout(() => {
      this.isLinear=false;
      this.stepper.selectedIndex = stepIndex;
      this.activeStepIndex = stepIndex;
      // Update step statuses
    for (let i = 0; i < 3; i++) {
      const statusInfo = this.getStatus(i);
      const labelStatusTwo = document.getElementById(`label-status-two-${i}`);
      const stepLabel = document.getElementById(`stepLabel-${i}`);
      if (labelStatusTwo) {
        labelStatusTwo.innerHTML = statusInfo.status;
        labelStatusTwo.className = statusInfo.className;
      }
    }
      switch (stepIndex) {
        case 0:
          this.stepContent = "content-1";
          this.serviceForm.controls['projectID'].setValue("");
          this.isLinear=true;
          break;
        case 1:
          this.productForm.controls['projectID'].setValue("");
          this.stepContent = "content-2";
          this.isLinear=true;
          break;
        case 2:
          this.stepContent = "content-3";
          this.isLinear=true;
          break;
        default:
          this.stepContent = "";
          this.isLinear=true;
      }
      // this.isLinear = true;
      this.cdr.detectChanges();
    }, 0);
  }

  updateStepContent(stepIndex: number) {
    // Update active step index
    this.activeStepIndex = stepIndex;

    // Update step statuses
    for (let i = 0; i < 3; i++) {
      const statusInfo = this.getStatus(i);
      const labelStatusTwo = document.getElementById(`label-status-two-${i}`);
      const stepLabel = document.getElementById(`stepLabel-${i}`);
      if (labelStatusTwo) {
        labelStatusTwo.innerHTML = statusInfo.status;
        labelStatusTwo.className = statusInfo.className;
      }
    }

    switch (stepIndex) {
      case 0:
        this.serviceForm.controls['projectID'].setValue("");
        this.stepContent = "content-1";
        break;
      case 1:
        this.productForm.controls['projectID'].setValue("");
        this.stepContent = "content-2";
        break;
      case 2:
        this.stepContent = "content-3";
        break;
      default:
        this.stepContent = "";
    }
  }

  getStatus(index: number): { status: string; className: string; completed: boolean } {
    let completed = false;
  
    if (index < this.activeStepIndex) {
      completed = true; 
    } else if (index === this.activeStepIndex) {
      switch (index) {
        case 2:
          completed = true || false;
          break;
        default:
          completed = false;
      }
    }
    if (index < this.activeStepIndex || this.activeStepIndex==2) {
      return { status: "Completed", className: "completed", completed: true };
    } else if (index === this.activeStepIndex) {
      return { status: "In Progress", className: "inProgress", completed };
    } else {
      return { status: "Pending", className: "pending", completed: false };
    }
  }

  hasError(form: FormGroup, controlName: string, errorName: string): boolean {
    const control = form.get(controlName);
    return !!control?.hasError(errorName) && (!!control?.touched);
  }

  GetUserData() {
    this.authService.GetProfileData().subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        this.userDetails = resJSON.data;
      } else {
        this.notificationService.showError(`${resJSON.message}`, '');
      }
    });
  }

  OnClickLogo() {
    const accessToken = localStorage.getItem('customer_access_token');
    if(accessToken){
      this.router.navigate(['/customer/quotation-proposal'])
    } else {
      let token=this.route.snapshot.queryParamMap.get('quote_token');
      if(token){
      window.close();
      window.open(this.memberDomain + `/member/quotation-proposal`, '_blank');
      }else{
        this.router.navigate([''])
      }
    }
  }

  EditProjectDetailsModal(ModalName: any){
    this.modalService.open(ModalName, { centered: true, windowClass: 'edit-custom-modal', size: 'md' });
    this.callApiBasedOnProjectType(this.projectID);
  }

  callApiBasedOnProjectType(projectID: string) {
    this.quotingService
      .GetProjectDatabyID(projectID)
      .subscribe(async (resJSON: any) => {
        if (resJSON.code == 200) {
          this.PatchUserData();
          this.projects = {
            iProjectID: resJSON.data.iProjectID,
            vProjectName: resJSON.data.vProjectName
          };
          this.projectType = resJSON.data.vProjectType;
            localStorage.setItem("projectID", resJSON.data.iProjectID);
            localStorage.setItem("projectType", resJSON.data.vProjectType);
            localStorage.setItem("ID", resJSON.data._id);
            this.uniqueID=resJSON.data._id;
            let redirectStep = resJSON.data.vFormStep && resJSON.data.vFormStep > 0 ? Number(resJSON.data.vFormStep) -1 : 0;
            localStorage.setItem('currentStepIndex', redirectStep.toString())
            localStorage.setItem("prId", resJSON.data.iProductRequirementId)
          this.PatchUserData();
        } else {
        }
      });
  }

  PatchUserData() {
    this.editProjectForm.patchValue({
      vProjectName: this.projects.vProjectName
    });
  }

  EditProject() {
    this.editProjectFormSubmitted = true;

    // Check if the form is invalid
    if (this.editProjectForm.invalid) {
     this.editProjectForm.markAllAsTouched();
      return;
    }

    const reqJSON = {
      vProjectName: this.editProjectForm.value.vProjectName,
      vDescription: "dummy description"
    };
    const id = localStorage.getItem('ID')
    // API Call Goes Here
    this.isLoading = true;
    this.quotingService.EditProject(id, reqJSON).subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        this.modalService.dismissAll();
        this.callApiBasedOnProjectType(this.projectID);
        this.editProjectForm.reset();
        this.notificationService.showSuccess(`${resJSON.message}`, "");
        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.notificationService.showError(`${resJSON.message}`, "");
      }
    });
  }

  isEQuoteRoute(): boolean {
    const accessToken = localStorage.getItem('customer_access_token') || localStorage.getItem('quote_token');
    return this.router.url.includes('/e-quotation') && accessToken !== null;
  }

  ChangePassword() {
    let token=this.route.snapshot.queryParamMap.get('quote_token');
    if(token){
    window.close();
    window.open(this.memberDomain + `/member/change-password`, '_blank');
    }else{
      this.router.navigate(['/customer/change-password']);
    }
  } 

  HandleLogout() {
    let token=this.route.snapshot.queryParamMap.get('quote_token');
    if(token){
      this.auth.Logout().subscribe((result: any) => {
        if (result.code == 200) {
          this.notificationService.showSuccess('You have been successfully logged out!');
        }
      });
      this.helper.ClearStorageData();
      window.open(this.memberDomain, '_blank');
    }else{
      this.helper.Logout();
    }
  }

}
